<template>
  <div v-if="visible" class="popup-overlay" @click="closePopup">
    <div class="popup-container" @click.stop>
      <div class="popup-header">
        <span class="popup-title">警告</span>
        <!-- Smaller close button -->
        <button class="close-btn" @click="closePopup">×</button>
      </div>
      <div class="popup-body">
          <p>資訊之芽的 Online Judge 已經搬移到<a href="https://tioj.sprout.tw" style="color: blue; font-weight: bold;">新版網站</a></p>
          <p>本網站之服務已經終止</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true, // Control visibility of the popup
    };
  },
  methods: {
    closePopup() {
      this.visible = false; // Hide the popup when close button or overlay is clicked
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-container {
  background-color: #fff8c2;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  position: relative;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popup-title {
  font-size: 18px;
  font-weight: bold;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px; /* Smaller font size for the cross */
  cursor: pointer;
  color: #333;
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  width: 20px; /* Fixed width to prevent stretching */
  height: 20px; /* Fixed height to match the width */
  text-align: center;
  line-height: 20px; /* Center the × character vertically */
}

.close-btn:hover {
  color: #ff0000; /* Optional: Change color when hovering over the close button */
}

.popup-body {
  margin-top: 15px;
}
</style>




// WEBPACK FOOTER //
// WarningMessage.vue?844a4b86